import { DefaultItemType } from 'bold-ui'
import { CustomSelectFieldProps, SelectField } from 'components/form'

export const items: DefaultItemType[] = [
  { value: 0.5 * 60, label: '30 minutos' },
  { value: 60, label: '1 hora (padrão)' },
  { value: 2 * 60, label: '2 horas' },
  { value: 4 * 60, label: '4 horas' },
  { value: 8 * 60, label: '8 horas' },
  { value: 0, label: 'Tempo indeterminado' },
]

export type IntervaloHorusSelectModel = DefaultItemType

export function IntervaloHorusSelectField(props: CustomSelectFieldProps) {
  const itemToString = (item: DefaultItemType) => item && item.label

  return (
    <SelectField
      label='Desabilitar durante'
      items={items}
      itemToString={itemToString}
      clearable={false}
      defaultValue={items[1] as any}
      {...props}
    />
  )
}
